/**
 * This file contains functions for storing and retrieving the map access token from memory.
 * It specifically does not store the token in any persistent storage because it's instance-specific.
 */

let mapAccessToken: string | null = null;

export const setMapAccessToken = (accessToken: string | null) => {
  mapAccessToken = accessToken;
};

export const getMapAccessToken = () => {
  return mapAccessToken;
};
